import {Component, inject} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {IFrequentlyAskedQuestions} from "../../../interfaces/IFrequentlyAskedQuestions";
import {IEditFrequentlyAskedQuestions} from "../../../interfaces/IEditFrequentlyAskedQuestions";
import {IDialogGenericData} from "../../../interfaces/IDialogGenericData";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {MatDialog} from "@angular/material/dialog";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatDivider} from "@angular/material/divider";
import {FaqsEditComponent} from "../faqs-edit/faqs-edit.component";
import {FaqGameAssociationDialogComponent} from "../faq-game-association-dialog/faq-game-association-dialog.component";
import {FrequentlyAskedQuestionsService} from "../../../services/frequently-asked-questions.service";
import {DialogFunctionService} from "../../../services/dialog-function.service";
import {ConfirmationActionDialogComponent} from "../../dialogs/confirmation-action-dialog/confirmation-action-dialog.component";

@Component({
  selector: 'app-faq-manage-actions',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatDivider
  ],
  templateUrl: './faq-manage-actions.component.html',
  styleUrl: './faq-manage-actions.component.css'
})
export class FaqManageActionsComponent implements ICellRendererAngularComp {
  private matDialog = inject(MatDialog);
  private faqService = inject(FrequentlyAskedQuestionsService);
  private dialogFunctionService = inject(DialogFunctionService);

  public faq!: IFrequentlyAskedQuestions;
  public params!: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.faq = params.data;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onEditClick(): void {
    const dialogRef = this.matDialog.open(FaqsEditComponent, {
      width: '700px',
      data: {faq: this.faq}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.params.onRefresh();
      }
    });
  }

  onManageGamesClick(): void {
    const dialogRef = this.matDialog.open(FaqGameAssociationDialogComponent, {
      width: '600px',
      data: {faq: this.faq}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.params.onRefresh();
      }
    });
  }

  onMakeSharedClick(): void {
    this.dialogFunctionService.setCallback(() => {
      const command: IEditFrequentlyAskedQuestions = {
        id: this.faq.Id,
        question: this.faq.Question,
        answer: this.faq.Answer,
        active: this.faq.Active,
        ScopeType: this.faq.ScopeType,
        shared: true,
        gameIds: []
      };

      return this.faq.ScopeType === 1
        ? this.faqService.editWebappFaq(command)
        : this.faqService.editAdminAppFaq(command);
    });

    const dialogData: IDialogGenericData = {
      title: 'Convert to Shared FAQ',
      message: `This will make the FAQ "<strong>${this.faq.Question}</strong>" available to all games. Are you sure you want to proceed?`,
      successMessage: 'FAQ converted to shared successfully',
      dataCyTag: 'confirm-convert-to-shared-button'
    };

    const dialogRef = this.matDialog.open(ConfirmationActionDialogComponent, {
      data: dialogData,
      width: '650px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.params.onRefresh();
      }
    });
  }

  onMakeGameSpecificClick(): void {
    const dialogRef = this.matDialog.open(FaqGameAssociationDialogComponent, {
      width: '600px',
      data: {
        faq: this.faq,
        convertToGameSpecific: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.params.onRefresh();
      }
    });
  }
}
